export default {
  websiteUrl: "https://visualestate.com",
  appLogo: process.env.REACT_APP_APP_LOGO,
  appNewLogo: process.env.REACT_APP_NEW_LOGO,
  appName: "Patricia"
};
